import React from "react";
import { useParams } from "react-router-dom";
import { getGameConfig } from "../games";
import { useGameplaySession } from "../hooks/useGameplaySession";
import { GameStatus } from "../types/gameplay";
import SpettriGame from "./SpettriGame";

const Spettri = () => {
  const { date } = useParams();
  const gameConfig = getGameConfig("spettri");
  
  // Use the new gameplay session hook
  const {
    puzzleConfig,
    state: sessionState,
    solutions: hookSolutions, // Only available when game is complete (won/lost)
    status,
    gameOver,
    won,
    justLost,
    justWon, // True only when user wins during this session
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
    dispatchHintEvent,
    hintAllowance,
    refreshHintAllowance,
    updateLocalState,
    isSignedIn,
  } = useGameplaySession(gameConfig.id, date, {
    deriveStatusFromLocalStorage: (data) => {
      if (data?.completed) return GameStatus.WON;
      if (data?.gameOver) return GameStatus.LOST;
      if (data?.lives < 5 || data?.feedback) return GameStatus.IN_PROGRESS;
      return GameStatus.NOT_STARTED;
    },
  });

  return (
    <SpettriGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={hookSolutions}
      status={status}
      gameOver={gameOver}
      won={won}
      justLost={justLost}
      justWon={justWon}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
      dispatchHintEvent={dispatchHintEvent}
      hintAllowance={hintAllowance}
      refreshHintAllowance={refreshHintAllowance}
      updateLocalState={updateLocalState}
      isSignedIn={isSignedIn}
    />
  );
};

export default Spettri;
